import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { VendorSetupDomestic } from './../../../models/VendorSetupDomestic';
import { VendorService } from './../../../services/vendor.service';
import { DataService } from './../../../services/data.service';
import { AccountService } from './../../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TaxForm } from './../../../models/TaxForm';
import { TaxFormFile } from './../../../models/TaxFormFile';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import * as njq from 'jquery';

@Component({
  selector: 'app-domestic-vendor-form',
  templateUrl: './domestic-vendor-form.component.html',
  styleUrls: ['./domestic-vendor-form.component.scss']
})
export class DomesticVendorFormComponent implements OnInit {
  public vendorSetup: VendorSetupDomestic = new VendorSetupDomestic();
  public isCustomer: any = ['yes', 'no'];
  public paymentMethodTypeArray: any = [
      {'name': 'ACH', 'value': 'ACH'}
    , {'name': 'CHECK', 'value': 'CHK'}
    , {'name': 'CREDIT CARD', 'value': 'CC'}
    , {'name': 'WIRE', 'value': 'WIR'}
  ];
  errorMsg: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation = false;
  public fileData: Uint8Array;
  showInvalidFileMessage = false;
  InvalidFileMessage: string;
  alive = true;
  reader: FileReader = new FileReader();
  taxForm: TaxForm = new TaxForm();
  taxFromFile: TaxFormFile = new TaxFormFile();
  inputVariable: any;
 
  

  constructor(private dataSvc: DataService,
    private vendorSvc: VendorService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private accountSvc: AccountService,
    private spinner: NgxSpinnerService) { }

    abaNumberMax: FormControl = new FormControl(Validators.maxLength(9));
    abaNumberMin: FormControl = new FormControl(Validators.minLength(9));

  ngOnInit() {
    this.vendorSetup.ContactCountry = 'United States';
    this.vendorSetup.ContactCountryRemit = 'United States';
    this.vendorSetup.ContactCurrency = 'USD';
    this.vendorSetup.ContactCurrencyRemit = 'USD';
  }

  onSubmit(frmVendorSetup: NgForm) {
    this.spinner.show();
    console.log('Submit  activated', frmVendorSetup);

    this.accountSvc.createVendorCreateRequest(this.vendorSetup)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.showSuccessConfirmation = true;
          console.log(data);
          this.spinner.hide();
        },
        err => {
          this.errorMsg = err;
          this.showFailConfirmation = true;
          this.spinner.hide();
        },
        () => {
          console.log('Request Complete');
          njq(".router-content").animate({ scrollTop: 0 }, "fast");
          this.spinner.hide();

        }
      );
  }

  redirectToVendorSetup(event) {
    this.router.navigate(['/pages/vendor-setup']);
  }

  checkPaymentMethod() {
    let result = true;
    switch(this.vendorSetup.PaymentNotificationMethod) {
      case 'CHK':
        result = false;
        break;
      case 'CC':
        result = false;
        break;
      default:
      result = true;
    }

    return result;

  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  wait2sec() {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve();
      }, 2000);
    });
  }

  resetFileInput() {
    this.inputVariable.nativeElement.value = '';
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
      this.fileData = new Uint8Array(this.reader.result);
    };
    /*this.reader.onprogress = function(data) {
      if (data.lengthComputable) {
        let progress = parseInt( ((data.loaded / data.total) * 100), 10 );
        console.log()
      }
    }*/
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }
  goToPreviousPage() {
    this._location.back();
  }
  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
  }

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  async handleFileInput(files: FileList) {
    console.log('first log');
    this.showInvalidFileMessage = false;
    if (files.length !== 1) {
      console.log('Only support upload 1 file');
      this.resetFileInput();
      return;
    }
    // File size limit, 11M
    if (files[0].size > 11534336) {
      this.InvalidFileMessage = 'This file\'s size exceeds the limit';
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    console.log('Inside handle');
    console.log(files.length);
    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();
    console.log('After handle');
    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.InvalidFileMessage = 'We don\'t support ' + fileExt + ' file';
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    this.spinner.show();
    this.readFile(files);
    await this.wait2sec();
    this.taxForm.FileName = Date.now().toString() + fileExt;
    this.taxForm.AttachmentFilePath = this.taxFromFile.fileName;
    // this.questionFile.fileData = btoa(this.fileData.reduce((data, byte) => data  + String.fromCharCode(byte), ''));
    // this.taxFromFile.fileData = this.arrayBufferToBase64(this.fileData);
    this.vendorSetup.FileBytesBase64 = this.arrayBufferToBase64(this.fileData);
    this.vendorSetup.FileName = this.taxForm.FileName;
    this.spinner.hide();

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor-setup/domestic-vendor-form/domestic-vendor-form.component.ts